:host{display:block}
/*# sourceMappingURL=active-eoc.component-WJADXP5Q.css.map */
